<template>
  <div class="container">
    <div style="text-align: center">
      <div>
        Please select a plan type to send email instruction, or simply click "Skip Email" to complete the action item.
      </div>
      <br />
      <amf-validation-wrapper :validator="$v.result.planType">  
        <input
          class="mt-1 mr-2 leftBrokerRadio"
          id="fsa"
          name="fsaPlanDoc"
          type="radio"
          v-model="result.planType"
          value="fsa"       
        />
        <label class="rightRadio" for="fsa">Fsa Docs</label>
        <br>
        <input
          class="mt-1 mr-2"
          id="hra"
          name="hraPlanDoc"
          type="radio"
          v-model="result.planType"
          value="hra"        
        />
        <label class="rightRadio" for="hra">Hra Docs</label>
         <br>
           <input
          class="mt-1 mr-2"
          id="sbc"
          name="sbcOnly"
          type="radio"
          v-model="result.planType"
          value="sbc"
        />
        <label class="rightRadio" for="sbc">SBC Only</label>
      </amf-validation-wrapper>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  inject: ["closeModal"],
  data() {
    return {
      result: {
        planType:null,
        skip: false,
      },
      title: "Send Email",
    };
  },
  props: ["item"],
  computed: {
    buttonsCustom() {
      return "$Skip Email";
    },
    buttons() {
      return "Send/Cancel";
    },
  },
  methods: {
    ...amfx.map("actionItems", "changeStatus"),
    send() {
      return this.result;
    },
    skipEmail() {
      this.result.skip = true;
      return this.result;
    },
  },
  validations() {
    return {
        result: {
          planType: v.build(v.required()),       
        },
    };
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/action-items/types/SendPlanDocEnrollments.vue